export default __webpack_public_path__ + "static/media/markup.8b11b25b.md";